import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";
import { ApiVisa } from "../shared/api-visa.model";
import { UserAppletContainerModel } from "../../../../../models/aggregates/applet-store/user-applet-container.model";
import { ApiResponseModel, BasicApiResponseModel, Pagination, PagingResponseModel } from "../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserAppletService extends BaseApiTemplateService<UserAppletContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "applet-login-subject-link";
    this.httpClient = http;
  }

  sysadminMultipleUninstall(dtoObject: string[], apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/sysadmin-ep/multi-uninstall";
    }

    let httpOptions = this.getHttpHeader(apiVisa);
    httpOptions.headers.append("Content-Type", "application/json");
    httpOptions["body"] = { applet_login_subject_link_guids: dtoObject };

    return this.httpClient.delete(this.apiUrl, httpOptions);
  }

  sysadminGetAppletCount(subjectGuid: string, apiVisa: ApiVisa){
    if(this.endpoint_path && apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep/applet-count/${subjectGuid}`;
    };
    return this.httpClient.get<BasicApiResponseModel<number>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  sysadminGetTenantCount(subjectGuid: string, apiVisa: ApiVisa){
    if(this.endpoint_path && apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + `/sysadmin-ep/tenant-count/${subjectGuid}`;
    };
    return this.httpClient.get<BasicApiResponseModel<number>>(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  getByLogin(
    appletGuid: string,
    tenantGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<UserAppletContainerModel>> {
    let url = this.apiUrl + "/login-ep/" + appletGuid + "/" + tenantGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/login-ep/" + appletGuid + "/" + tenantGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<UserAppletContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  tenantAdminMultipleUninstall(tenantCode: string, dtoObject: string[], apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/tenant-admin-ep/" + tenantCode + "/multi-uninstall";
    }
    let httpOptions = this.getHttpHeader(apiVisa);
    httpOptions.headers.append("Content-Type", "application/json");
    httpOptions["body"] = { applet_login_subject_link_guids: dtoObject };
    return this.httpClient.delete(this.apiUrl, httpOptions);
  }

  tenantAdminGetAppletCount(tenantCode: string, subjectGuid: string, apiVisa: ApiVisa){
    if(this.endpoint_path && apiVisa.api_domain_url){
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/tenant-ep/applet-count?loginSubjectGuid=' + subjectGuid;
    };
    return this.httpClient.get<BasicApiResponseModel<number>>(this.apiUrl, this.getHttpHeader(apiVisa));
  } 


  // /core2/platform/dm/applet-login-subject-link/{tenantCode}/tenant-admin-ep/query?
  tenantAdminGetByCriteria(tenantCode: string, pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/tenant-admin-ep/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

    // /core2/platform/dm/applet-login-subject-link/available-applets/{tenantCode}/tenant-admin-ep/{subjectGuid}/query
  getAvailableAppletsForUsers(tenantCode: string, subjectGuid: string, pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/available-applets/' + tenantCode + '/tenant-admin-ep/' + subjectGuid + '/query?' + pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

}
